import { PureAbility, AbilityBuilder, defineAbility, SubjectType } from '@casl/ability';
import { ActiveUser } from './active-user.model';
import { ModulesNames } from './consts/modules.const';
import { ROLES } from './consts/roles.const';

export class ACLBuilder {
  static build(user: ActiveUser) {
    return defineAbility((can, cannot) => {
      if (user.hasRole(ROLES.MASTER)) {
        can('manage', 'all');
      } else if (user.hasRole(ROLES.SUPER_ADMIN)) {
        can('manage', 'all', {});
      } else if (user.hasRole(ROLES.ADMIN)) {
        // Explicitly type the mods array
        const mods: SubjectType[] = [
          // Your modules here
          // For example:
          // ModulesNames.POSTS,
          // ModulesNames.COMMENTS,
          // etc.
        ];
        
        can(['read', 'create'], mods);
        can(['edit', 'delete'], mods, {
          author: { id: user.id },
        });
      } else if (user.hasRole(ROLES.USER)) {
        can('read', 'all', {});
        cannot('read', ModulesNames.USERS);
      }
    });
  }
}